/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type EnrollmentPrompt_user$ref = any;
type TpnRewardsDashboard_user$ref = any;
type TpnRewardsDashboard_viewer$ref = any;
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type TradeFirmLoyaltyStatus = "BLACKLISTED" | "ELIGIBLE" | "ENROLLED" | "NOT_ELIGIBLE" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type RewardsWrapper_viewer$ref: FragmentReference;
export type RewardsWrapper_viewer = {|
  +user?: ?{|
    +isVerifiedTrade: ?boolean,
    +tradeFirm: ?{|
      +profileStatus: ?DesignProfileStatus,
      +loyalty: ?{|
        +status: ?TradeFirmLoyaltyStatus
      |},
    |},
    +$fragmentRefs: TpnRewardsDashboard_user$ref & EnrollmentPrompt_user$ref,
  |},
  +$fragmentRefs: TpnRewardsDashboard_viewer$ref,
  +$refType: RewardsWrapper_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "RewardsWrapper_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TpnRewardsDashboard_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "TpnRewardsDashboard_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "EnrollmentPrompt_user",
              "args": null
            },
            {
              "kind": "ScalarField",
              "alias": "isVerifiedTrade",
              "name": "hasPermission",
              "args": [
                {
                  "kind": "Literal",
                  "name": "name",
                  "value": "B_NET_PRICE",
                  "type": "String!"
                }
              ],
              "storageKey": "hasPermission(name:\"B_NET_PRICE\")"
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "tradeFirm",
              "storageKey": null,
              "args": null,
              "concreteType": "TradeFirmType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "profileStatus",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "loyalty",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TradeFirmLoyaltyType",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "status",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b08c1deba9f21ddf99fdf32c558e802e';
module.exports = node;
